package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.model.EventContent
import fr.manyverse.app.domain.model.EventType
import fr.manyverse.app.domain.model.GameEvent
import fr.manyverse.app.domain.repository.GameEventRepository

/**
 * Records an item sent to players: the recipients are notified and the GM sees it in the history.
 * [senderName] is null when the GM sent the item.
 */
class NotifyItemSentUseCase(
    private val gameEventRepository: GameEventRepository
) {
    suspend operator fun invoke(
        tableId: String,
        triggeredBy: String,
        recipientUserIds: List<String>,
        senderName: String?,
        recipientNames: List<String>,
        itemName: String,
        quantity: Int
    ): Result<GameEvent> = gameEventRepository.createEvent(
        tableId = tableId,
        type = EventType.ITEM_SENT,
        triggeredBy = triggeredBy,
        targetParticipants = recipientUserIds,
        content = EventContent.ItemSent(
            senderName = senderName,
            recipientNames = recipientNames,
            itemName = itemName,
            quantity = quantity
        )
    )
}
